import React, { useState, useRef } from "react";
import styles from "./index.modules.less";
import SoftInfo from "../../image/info.svg";
import Ellipsis from "../../image/ellipsis.svg";
import CardInfo from "../../components/CardInfo";

const CardItem = ({ data: item, index }) => {
  const timerRef = useRef(null);
  const [modelShow, setModelShow] = useState({ type: false });
  const showCard = (item, e) => {
    timerRef.current && clearTimeout(timerRef.current);
    const x = e.target.offsetLeft + 24 - 104;
    const y = e.target.offsetTop + 20;
    timerRef.current = setTimeout(() => {
      setModelShow({
        type: true,
        x,
        y,
        record: item,
      });
    }, 300);
  };

  const hideCard = () => {
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setModelShow({
        type: false,
        x: 0,
        y: 0,
        record: null,
      });
    }, 300);
  };

  return (
    <div key={index} className={styles.cardItem}>
      <div
        style={{
          backgroundImage: `url(https://p4.ssl.qhimg.com/t01aaa56f1c8ca66a7b.png)`,
        }}
        className={styles.cardBg}
      ></div>
      <div className={styles.cardInfo}>
        <div className={styles.cardTit}>
          {item.soft_name} <span>{item.soft_cate_human}</span>
        </div>
        <div className={styles.version}>
          <span className={styles.versionText}>版本：{item.version}</span>
          <span onMouseLeave={hideCard} onMouseEnter={(e) => showCard(item, e)}>
            <SoftInfo
              className={styles.icon}
              color="#999999"
              width="16"
              height="16"
            ></SoftInfo>
          </span>
        </div>
        <div className={styles.cardTime}>{item.create_time} </div>
      </div>
      <div className={styles.rSide}>
        <div className={styles.iconWrapper}>
          <Ellipsis
            style={{
              verticalAlign: "middle",
            }}
            color="#999999"
            width="15"
            height="3"
          ></Ellipsis>
        </div>
        <div className={styles.status}>{item.audit_status}</div>
      </div>
      {modelShow.type ? (
        <CardInfo
          style={{
            left: modelShow.x,
            top: modelShow.y,
          }}
          pRef={timerRef}
          data={modelShow.record}
          hideCard={hideCard}
          showCard={showCard}
        ></CardInfo>
      ) : null}
    </div>
  );
};

export default CardItem;
